import { frontDoor } from '../../../front-door/config'
import type { FoundHook, LauncherFound } from '../../../front-door/launcher/feed'
import { useSearchAll } from './data'
import { hitTag, resolveLink } from './shape'

/** The front page search box's hook: the database search, with each hit's link made safe and ready to open. */
export const useFoundHits: FoundHook = (q) => {
  const s = useSearchAll(q)
  const results = s.hits.flatMap((h, i): LauncherFound[] => {
    const dest = resolveLink(h.link, frontDoor.domain)
    if (!dest) return []
    return [{ id: `${h.kind}:${i}:${h.link}`, title: h.title, sub: h.sub, tag: hitTag(h), app: h.app, href: dest.href, external: dest.external }]
  })
  return { results, loading: s.loading, failed: s.failed }
}
